import React from "react";
import request from "arcdynamic-request";
import InfoColumns from '../Stats/InfoColumns';
import {HscStatsData} from './models/hscstats';
import {executeQuery} from "../../requests/executeQuery";
import {STATS_BY_TYPE, STATS_BY_BUYER_STATE, PRIME_RATES, STATS_BY_STATUS_HSC} from '../../consts/queries';
import axios from "axios";
import Icon from "../Icon";
import svgRefresh from "../../svgs/Refresh.svg";
import HscStatsColumns from "../Stats/HscStatsColumns";
import { formatArcimedesModified } from "../../utils";
import { apiSyncRatesUrl } from "../../requests/apiBaseUrls";

const cloneDeep = require('lodash.clonedeep');

function hscRatesFromRow(row) {
    return {
        US_TREASURY_1YR: row.US_TREASURY_1YR,
        US_TREASURY_3YR: row.US_TREASURY_3YR,
        US_TREASURY_5YR: row.US_TREASURY_5YR,
        US_TREASURY_7YR: row.US_TREASURY_7YR,
        US_TREASURY_10YR: row.US_TREASURY_10YR,
        SOFR_SWAP_1YR: row.SOFR_SWAP_1YR,
        SOFR_SWAP_3YR: row.SOFR_SWAP_3YR,
        SOFR_SWAP_5YR: row.SOFR_SWAP_5YR,
        SOFR_RATE: row.SOFR_RATE,
        PRIME_RATE: row.PRIME_RATE,
        FED_FUNDS_RATE: row.FED_FUNDS_RATE,
        CURRENT_US_TREASURY_1YR: row.CURRENT_US_TREASURY_1YR,
        CURRENT_US_TREASURY_3YR: row.CURRENT_US_TREASURY_3YR,
        CURRENT_US_TREASURY_5YR: row.CURRENT_US_TREASURY_5YR,
        CURRENT_US_TREASURY_7YR: row.CURRENT_US_TREASURY_7YR,
        CURRENT_US_TREASURY_10YR: row.CURRENT_US_TREASURY_10YR,
        CURRENT_SOFR_SWAP_1YR: row.CURRENT_SOFR_SWAP_1YR,
        CURRENT_SOFR_SWAP_3YR: row.CURRENT_SOFR_SWAP_3YR,
        CURRENT_SOFR_SWAP_5YR: row.CURRENT_SOFR_SWAP_5YR,
        CURRENT_SOFR_RATE: row.CURRENT_SOFR_RATE,
        CURRENT_PRIME_RATE: row.CURRENT_PRIME_RATE,
        CURRENT_FED_FUNDS_RATE: row.CURRENT_FED_FUNDS_RATE,
    };
}

export default class HscStats extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stats: new HscStatsData({}),
            totalClosedSum: null,
            totalClosedCount: null,
            isYtdClosing: true,
            fiveYear:'',
            tenyear:'',
            fiveYearChart:{},
            tenYearChart: {},
            oneMonthSOFR: '0%',
            oneYearSOFR: '0%',
            oneYearForTenYearUTR: '0%',
            oneYearForFiveYearSOFR: '0%',
            oneYearPrimeRate: '0%',
            hscRates:{
                "US_TREASURY_1YR": "0%",
                "US_TREASURY_3YR": "0%",
                "US_TREASURY_5YR": "0%",
                "US_TREASURY_7YR": "0%",
                "US_TREASURY_10YR": "0%",
              
                "SOFR_SWAP_1MO": "0%",
                "SOFR_SWAP_1YR": "0%",
                "SOFR_SWAP_3YR": "0%",
                "SOFR_SWAP_5YR": "0%",
              
                "SOFR_RATE": "0%",
                "PRIME_RATE": "0%",
                "FED_FUNDS_RATE": "0%",

                "CURRENT_US_TREASURY_1YR": "0%",
                "CURRENT_US_TREASURY_3YR": "0%",
                "CURRENT_US_TREASURY_5YR": "0%",
                "CURRENT_US_TREASURY_7YR": "0%",
                "CURRENT_US_TREASURY_10YR": "0%",
                "CURRENT_SOFR_SWAP_1YR": "0%",
                "CURRENT_SOFR_SWAP_3YR": "0%",
                "CURRENT_SOFR_SWAP_5YR": "0%",
                "CURRENT_SOFR_RATE": "0%",
                "CURRENT_PRIME_RATE": "0%",
                "CURRENT_FED_FUNDS_RATE": "0%",
              },
            ratesLastUpdated: '',
            ratesSyncLoading: false,
        };
        this.handleSyncRates = this.handleSyncRates.bind(this);
        this.handleSyncRatesKeyDown = this.handleSyncRatesKeyDown.bind(this);
    }

    refreshHscRates() {
        const that = this;
        return request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', 'HSC_RATES'],
        }).then((res) => {
            if (res && res.success && Array.isArray(res.data) && res.data[0]) {
                const row = res.data[0];
                that.setState({
                    hscRates: hscRatesFromRow(row),
                    ratesLastUpdated: formatArcimedesModified(row.ARCIMEDES_MODIFIED),
                });
            }
        });
    }

    handleSyncRates(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        if (this.state.ratesSyncLoading) {
            return;
        }
        this.setState({ ratesSyncLoading: true });
        axios
            .get(apiSyncRatesUrl)
            .then((response) => {
                const data = response && response.data;
                if (data && data.success) {
                    return this.refreshHscRates();
                }
                const msg = (data && data.message) || 'Sync failed.';
                window.alert(msg);
            })
            .catch((err) => {
                const data = err.response && err.response.data;
                const msg = (data && data.message) || err.message || 'Request failed.';
                window.alert(msg);
            })
            .then(() => {
                this.setState({ ratesSyncLoading: false });
            });
    }

    handleSyncRatesKeyDown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleSyncRates(e);
        }
    }

    fetch() {
        const ytd = new Date().getFullYear();
        const firstDayOfYtd = `${ytd}-01-01`;
        const firstDayPriorYtd = `${ytd - 1}-01-01`;
        const sinceDate = `${ytd - 2}-01-01`; // since 2 years ago

        Promise.all([
            executeQuery({queryName: STATS_BY_STATUS_HSC, params: {}}),
            executeQuery({queryName: STATS_BY_TYPE, params: {}}),
            executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: firstDayOfYtd}}),
            executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: firstDayPriorYtd}}),
            executeQuery({queryName: STATS_BY_BUYER_STATE, params: {DATE: sinceDate}}),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', PRIME_RATES]                     
                }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', 'HSC_RATES']                     
                }),
        ]).then((res) => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data) &&
                res[2] && res[2].success && Array.isArray(res[2].data) &&
                res[3] && res[3].success && Array.isArray(res[3].data) &&
                res[4] && res[4].success && Array.isArray(res[4].data) && 
                res[5] && res[5].success && Array.isArray(res[5].data) &&
                res[6] && res[6].success && Array.isArray(res[6].data)) {
                const stats = new HscStatsData({
                    dataByStatus: res[0].data[0],
                    dataByType: res[1].data[0],
                });
                const isYtdClosing = !(res[0].data[0] && res[0].data[0].CLOSED_YTD_PROPERTIES && parseInt(res[0].data[0].CLOSED_YTD_PROPERTIES) < 1);

                const {listedChartData, soldChartData} = cloneDeep(this.state);
                // listedChartData[0].y = stats.activeStnlCount;
                // listedChartData[1].y = stats.activeMtCount;
                // soldChartData[0].y = stats.closedStnlCount;
                // soldChartData[1].y = stats.closedMtCount;

                let sum = res[1].data[0].CLOSED_PRICE;
                let count = res[1].data[0].CLOSED_COUNT;
                sum = (sum / Math.pow(10, 9)).toString();
                sum = sum.slice(0, sum.indexOf('.') + 2);
                count = parseInt(count / 25) * 25;


                // let chartData = Stats.buildBuyerStateChartData(isYtdClosing ? res[2].data : res[3].data);
                // const buyerStateYtdChartData = chartData.chartOptionsData;
                // const buyerStateYtdTotal = chartData.total;
                // chartData = Stats.buildBuyerStateChartData(res[4].data);
                // const buyerStateChartData = chartData.chartOptionsData;
                // const buyerStateTotal = chartData.total;
                // {key: 'Transactions', value: stats.loanInProcessCount},
                const primeRates = [
                    {
                        key:'Prime Rate', value:res[5].data[0].THIS_WEEK
                    },
                ]
                const hscRow = res[6].data[0];
                this.setState({
                    stats,
                    listedChartData,
                    soldChartData,
                    totalClosedSum: sum,
                    totalClosedCount: count,
                    isYtdClosing,
                    primeRates,
                    hscRates: hscRatesFromRow(hscRow),
                    ratesLastUpdated: formatArcimedesModified(hscRow.ARCIMEDES_MODIFIED),
                });
            }
        });
    }

    componentDidMount() {
        this.fetch();
    }

    render() {
        const {stats, isYtdClosing, fiveYear, tenyear, tenYearChart, primeRates, oneMonthSOFR, oneYearSOFR, oneYearForTenYearUTR, oneYearForFiveYearSOFR, oneYearPrimeRate, hscRates, ratesLastUpdated, ratesSyncLoading} = this.state;
            const ytd = new Date().getFullYear();
        let rates =[
            {key: '1 Mo SOFR', value: oneMonthSOFR},
            {key: '5 Yr UST', value: fiveYear},
            {key: '10 Yr UST', value: tenyear},
        ]
        if(primeRates){
            rates=[
                ...rates,
                ...primeRates
            ]
        }
        let oneYearRates =[
            {key: '1 Yr Ago', value: oneYearSOFR, className: 'marginLeft5'},
            {key: '1 Yr Ago', value: oneYearForFiveYearSOFR},
            {key: '1 Yr Ago', value: oneYearForTenYearUTR},
            {key: '1 Yr Ago', value: oneYearPrimeRate},
        ]

        let usTreasury = [
            {label: '1 Yr', current: hscRates.CURRENT_US_TREASURY_1YR, prior: hscRates.US_TREASURY_1YR},
            {label: '3 Yr', current: hscRates.CURRENT_US_TREASURY_3YR, prior: hscRates.US_TREASURY_3YR},
            {label: '5 Yr', current: hscRates.CURRENT_US_TREASURY_5YR, prior: hscRates.US_TREASURY_5YR},
            {label: '7 Yr', current: hscRates.CURRENT_US_TREASURY_7YR, prior: hscRates.US_TREASURY_7YR},
            {label: '10 Yr', current: hscRates.CURRENT_US_TREASURY_10YR, prior: hscRates.US_TREASURY_10YR},
        ]

        let newOneMonthSOFR = [
            {label: '1 Yr', current: hscRates.CURRENT_SOFR_SWAP_1YR, prior: hscRates.SOFR_SWAP_1YR},
            {label: '3 Yr', current: hscRates.CURRENT_SOFR_SWAP_3YR, prior: hscRates.SOFR_SWAP_3YR},
            {label: '5 Yr', current: hscRates.CURRENT_SOFR_SWAP_5YR, prior: hscRates.SOFR_SWAP_5YR},
        ]

        let sofr = [
            {label: 'SOFR', current: hscRates.CURRENT_SOFR_RATE, prior: hscRates.SOFR_RATE},
            {label: 'Prime', current: hscRates.CURRENT_PRIME_RATE, prior: hscRates.PRIME_RATE},
            {label: 'Fed Funds', current: hscRates.CURRENT_FED_FUNDS_RATE, prior: hscRates.FED_FUNDS_RATE},
        ]
        return (
            <div className='Stats'>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container'>
                        <div className='page-header'>
                            <div className='page-title'>Stats</div>
                            <div className='stats-update-container'>
                                <div>
                                    Rates Last Updated {ratesLastUpdated || '—'}
                                </div>
                                <div
                                    className="stats-update-icon"
                                    onClick={this.handleSyncRates}
                                    onKeyDown={this.handleSyncRatesKeyDown}
                                    role="button"
                                    tabIndex={0}
                                    title="Sync rates"
                                >
                                    <Icon className={ratesSyncLoading ? 'loading' : ''} svg={svgRefresh}/>
                                </div>
                            </div>
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='stats-container page-body-container'>
                    <div className='stats-columns'>
                        <div className='stats-column first'>
                        <InfoColumns title={`Closings - ${isYtdClosing ?  'YTD' : ytd - 1}`}
                                         titleRedirect={`/list?SOURCE=PEAK&PEAK_STATUS=Closed&CLOSE_OF_ESCROW_MIN=01%2F01%2F${isYtdClosing ?  ytd : ytd - 1}&CLOSE_OF_ESCROW_MAX=12%2F31%2F${isYtdClosing ?  ytd : ytd - 1}`}
                                         columns={[
                                             {key: 'Transactions', value: stats.closedYtdCount},
                                             {key: 'Total Loan Amount', value: stats.closedYtdLoanAmount},
                                             {key: 'Avg Rate', value: stats.closedYtdAvgrate}
                                         ]}
                            />
                            <div className='line'/>
                            <InfoColumns title={`Loan In Process`}
                                titleRedirect={`/list?SOURCE=PEAK&PEAK_STATUS=Loan In Process`}
                                columns={[
                                    {key: 'Transactions', value: stats.loanInProcessCount},
                                    {key: 'Total Loan Amount', value: stats.loanAmount},
                                    {key: 'Avg Rate', value:stats.loanInProgressAvgrate}
                                ]}
                            />
                            <div className='line'/>
                            <InfoColumns title={`Courting`}
                                titleRedirect={`/list?SOURCE=PEAK&PEAK_STATUS=Courting`}
                                columns={[
                                    {key: 'Transactions', value: stats.courtingTransactions},
                                    {key: 'Total Loan Amount', value: stats.courtingLoanAmount},
                                    {key: 'Avg Rate', value:stats.courtingAvgRate}
                                ]}
                            />
                             <div className='line'/>
                            <InfoColumns title={`Closings - Total`}
                                titleRedirect={`/list?SOURCE=PEAK&PEAK_STATUS=Closed`}
                                columns={[
                                    {key: 'Transactions', value: stats.closedTotalCount},
                                    {key: 'Total Loan Amount', value: stats.closedTotalLoanAmount},
                                    {key: 'Avg Rate', value: stats.closedTotalAvgRate},
                                ]}
                            />
                        </div>
                        <div className='stats-column last'>
                            <HscStatsColumns title={`US Treasuries`}
                                columns={usTreasury}/>
                            <HscStatsColumns title={`1 Mo SOFR Swap`}
                                columns={newOneMonthSOFR}/>
                            <HscStatsColumns title={`Key Rates`}
                                columns={sofr}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}